(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var registeredGalleries = new WeakSet();

  function getDirectSlides(slideshow) {
    return Array.from(
      slideshow.querySelectorAll('slideshow-slide')
    ).filter(function (slide) {
      return slide.closest('slideshow-component') === slideshow;
    });
  }

  function resetGalleryToFirstImage(gallery) {
    if (!mobileQuery.matches) return;
    if (gallery.dataset.bussaUserInteracted === 'true') return;

    var slideshow = gallery.querySelector('slideshow-component');
    if (!slideshow) return;

    var slides = getDirectSlides(slideshow);
    var firstSlide = slides[0];

    if (!firstSlide) return;

    slideshow.setAttribute('initial-slide', '0');

    var firstSlideId = firstSlide.getAttribute('slide-id');

    if (
      firstSlideId &&
      typeof slideshow.select === 'function'
    ) {
      try {
        slideshow.select(
          { id: firstSlideId },
          undefined,
          { animate: false }
        );
      } catch (error) {
        // Le déplacement manuel ci-dessous prend le relais.
      }
    }

    var scroller =
      slideshow.querySelector('[ref="scroller"]') ||
      slideshow.querySelector('slideshow-container') ||
      slideshow.querySelector('.slideshow__slides');

    if (scroller) {
      scroller.scrollLeft = 0;

      if (typeof scroller.scrollTo === 'function') {
        scroller.scrollTo({
          left: 0,
          top: 0,
          behavior: 'auto'
        });
      }
    }

    gallery.querySelectorAll('.card-gallery-dot').forEach(
      function (dot, index) {
        dot.classList.toggle('is-active', index === 0);
      }
    );
  }

  function resetWithRetries(gallery) {
    [0, 100, 300, 700, 1200].forEach(function (delay) {
      window.setTimeout(function () {
        resetGalleryToFirstImage(gallery);
      }, delay);
    });
  }

  var visibilityObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        resetWithRetries(entry.target);
        visibilityObserver.unobserve(entry.target);
      });
    },
    {
      threshold: 0.01
    }
  );

  function registerGallery(gallery) {
    if (registeredGalleries.has(gallery)) return;

    registeredGalleries.add(gallery);

    gallery.addEventListener(
      'pointerdown',
      function () {
        gallery.dataset.bussaUserInteracted = 'true';
      },
      {
        once: true,
        passive: true
      }
    );

    visibilityObserver.observe(gallery);
  }

  function scanForGalleries(root) {
    if (!root) return;

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('.card-gallery')
    ) {
      registerGallery(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.card-gallery').forEach(registerGallery);
    }
  }

  function start() {
    scanForGalleries(document);

    var pageObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          scanForGalleries(node);
        });
      });
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanForGalleries(event.target);
  });
})();